module.exports = __webpack_public_path__ + "static/index/img/baikal-120.1a130933.jpg";